// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// load fonts
WebFont.load({
    google: { // add &display=swap to end of ONLY END font family, not every single one, other it doesnt load those fonts after
        families: ['Open Sans:400,500,600,700&display=swap']
    },
    active: function() { // helps stop flash of unstyled text
        sessionStorage.fontsLoaded = true
    }
});

// Load BS
require('bootstrap');

//Load Libraries

require('magnific-popup/dist/jquery.magnific-popup.min');
require('objectFitPolyfill/dist/objectFitPolyfill.min');
require('select2/dist/js/select2.full.min');
require('slick-slider/slick/slick.min');

//Load Modules
require('./modules/accordion');
require('./modules/formInputs');
require('./modules/menu');
require('./modules/searchActive');
require('./modules/shareSocial');
require('./modules/tabs');
require('./modules/videoblock');
require('./modules/twolglink');
require('./modules/changeImage');
require('./modules/sliderImage');
require('./modules/sliderServices');
require('./modules/sliderNews');
require('./modules/sliderTabs');